import React from 'react';
import propTypes from 'prop-types';
import { calcMapBounds, calcCentroidFromBounds } from './mapLayoutCalcs';

import { Map } from './leaflet';

const BaseMap = ({
  bounceAtZoomLimits,
  boundaries,
  boundariesPadding,
  children,
  className,
  drawState,
  googleCredentials,
  isAppMode,
  onClick,
  onDrawShapeComplete,
  onLeafletZoomEnd,
  showScale,
  showZoomControl,
  unitsOfMeasure,
  viewOrigin,
  zoom
}) => {
  const {fitBounds, maxBounds} = calcMapBounds({boundaries, isAppMode, fitBoundsPadding:boundariesPadding});
  if (!viewOrigin && maxBounds) {
    // Purposefully avoiding use of field centroid, as this more reliably avoids map jitters.
    viewOrigin = calcCentroidFromBounds(maxBounds);
  }

  return (
    <Map
      bounceAtZoomLimits={bounceAtZoomLimits}
      className={className}
      drawState={drawState}
      fitBounds={fitBounds}
      googleConfig={googleCredentials}
      maxBounds={maxBounds}
      onClick={onClick}
      onDrawShapeComplete={onDrawShapeComplete}
      onLeafletZoomEnd={onLeafletZoomEnd}
      showScale={showScale}
      showZoomControl={showZoomControl || !isAppMode}
      unitsOfMeasure={unitsOfMeasure}
      viewOrigin={viewOrigin}
      zoom={zoom}>
      {children}
    </Map>
  );
};

BaseMap.propTypes = {
  bounceAtZoomLimits: propTypes.bool.isRequired,
  boundaries: propTypes.object,
  boundariesPadding: propTypes.number,
  children: propTypes.node.isRequired,
  className: propTypes.string.isRequired,
  drawState: propTypes.string,
  googleCredentials: propTypes.object.isRequired,
  isAppMode: propTypes.bool.isRequired,
  onClick: propTypes.func,
  onDrawShapeComplete: propTypes.func,
  onLeafletZoomEnd: propTypes.func.isRequired,
  showScale: propTypes.bool.isRequired,
  showZoomControl: propTypes.bool,
  unitsOfMeasure: propTypes.string,
  viewOrigin: propTypes.array,
  zoom: propTypes.number
};


export default BaseMap;
